export const shareNSNPopup = () => {
  //lightbox
  $('a[href="#share-nsn-popup"]').click(function (e) {
    e.preventDefault();

    $('#share-nsn-popup').fadeIn(150).css('display', 'flex');

    $('body').addClass('locked');
  });

  $('body').on('click', '.popup-closer', function () {
    $('#share-nsn-popup').hide();
    $('body').removeClass('locked');
    return false;
  });

  $('body').on('click', '#share-nsn-popup', function () {
    $('#share-nsn-popup').hide();
    $('body').removeClass('locked');
    return false;
  });

  $('body').on('click', '.popup-contents', function (e) {
    e.stopPropogation();
  });

  $(document).on('keydown', function (event) {
    if (event.key == 'Escape') {
      $('#share-nsn-popup').hide();
      $('body').removeClass('locked');
    }
  });
};
